<img class="slot" [class.visible]="showA" [src]="imgA" alt="">
<img class="slot" [class.visible]="!showA" [src]="imgB" alt="">
